import React from 'react';
import { motion } from 'framer-motion';
import { Home, Leaf } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function RetreatsSection() {
  const {
    t
  } = useLanguage();
  return <section id="retiros" className="py-16 sm:py-20 md:py-32 px-4 sm:px-6 bg-sage-lighter/20 relative" data-id="element-725">
      <div className="max-w-6xl mx-auto" data-id="element-726">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-12 md:mb-16" data-id="element-727">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-forest-dark mb-6 uppercase leading-tight" data-id="element-728">
            {t('retiros.title')}
          </h2>
          <div className="w-16 h-[1px] bg-sage-dark mx-auto" data-id="element-729"></div>
        </motion.div>

        {/* Hero image of Cal Faro */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="relative aspect-[16/10] sm:aspect-[16/9] rounded-[1.5rem] sm:rounded-[3rem] overflow-hidden shadow-2xl mb-8 sm:mb-12 border border-sage-light/30" data-id="element-730">
          <img src="https://cdn.magicpatterns.com/uploads/4PDav5KtiD9zLJ88535sMY/foto_5.jpg" alt="Casa Cal Faro entre bosques y montaña" className="w-full h-full" style={{
          filter: 'contrast(1.1) brightness(1.02)',
          imageRendering: 'crisp-edges',
          objectFit: 'cover'
        }} data-id="element-731" />
          <div className="absolute inset-0 bg-gradient-to-t from-forest-dark/50 via-transparent to-transparent" data-id="element-732"></div>
          <div className="absolute bottom-0 left-0 p-6 sm:p-10 md:p-14" data-id="element-733">
            <p className="text-cream font-serif italic text-lg sm:text-2xl md:text-3xl drop-shadow-lg max-w-md leading-snug" data-id="element-734">
              {t('retiros.closing')}
            </p>
          </div>
        </motion.div>

        {/* First paragraph + interior photo */}
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-10 mb-8 sm:mb-12 items-stretch" data-id="element-735">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white/70 backdrop-blur-md rounded-[1.5rem] sm:rounded-[2.5rem] p-6 sm:p-10 md:p-12 shadow-soft border border-sage-light/30 text-base sm:text-lg text-forest/80 font-light leading-relaxed flex items-center" data-id="element-736">
            <p data-id="element-737">{t('retiros.p1')}</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative aspect-[4/3] lg:aspect-auto rounded-[1.5rem] sm:rounded-[2.5rem] overflow-hidden shadow-xl border border-sage-light/30 min-h-[280px]" data-id="element-738">
            <img src="https://cdn.magicpatterns.com/uploads/5CxaWGz1Hm1T5drCdp57RP/foto_6.jpg" alt="Espacio interior de Casa Cal Faro" className="w-full h-full object-cover" data-id="element-739" />
          </motion.div>
        </div>

        {/* Remaining text + CTAs */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white/70 backdrop-blur-md rounded-[1.5rem] sm:rounded-[3rem] p-6 sm:p-10 md:p-16 shadow-soft border border-sage-light/30 space-y-6 sm:space-y-8" data-id="element-740">
          <p className="text-base sm:text-lg text-forest/80 font-light leading-relaxed" data-id="element-741">
            {t('retiros.p2')}
          </p>
          <p className="text-lg sm:text-xl font-medium text-forest-dark leading-relaxed" data-id="element-742">
            {t('retiros.p3')}
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 pt-4 sm:pt-6" data-id="element-743">
            <a href="https://www.casacalfaro.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-6 sm:px-8 py-4 bg-forest text-cream font-medium rounded-full hover:bg-forest-dark transition-colors shadow-lg text-sm sm:text-base" data-id="element-744">
              <Home className="w-5 h-5 flex-shrink-0" data-id="element-745" />
              <span className="text-center" data-id="element-746">{t('retiros.btn1')}</span>
            </a>
            <a href="https://www.casacalfaro.com/proximos-retiros" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-6 sm:px-8 py-4 bg-sage-dark text-cream font-medium rounded-full hover:bg-forest transition-colors shadow-lg text-sm sm:text-base" data-id="element-747">
              <Leaf className="w-5 h-5 flex-shrink-0" data-id="element-748" />
              <span className="text-center" data-id="element-749">{t('retiros.btn2')}</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}